module.exports = __webpack_public_path__ + "media/images/icons/outlined/filter-df7f2998f438ddc46ad380b096a2fd63.svg";